<div class="grid-x grid-margin-x section">
  <form [formGroup]="form">
    @if (hasFieldNotes('apiNumber')) {
      <div>
        <view-notes [fieldName]="'apiNumber'" [notes]="getFilteredNotes('apiNumber')" (notesRequested)="handleNotesRequested($event)"></view-notes>
      </div>
    }
    <well-selector [organization]="organization" [enableSelections]="enableWellSelection" [reportType]="reportType" (throw)="handleError($event)" (selectedWells)="onWellsSelected($event)"></well-selector>

    @if (filesUploaded == false) {
      <div class="cell small-12 medium-12 large-12">
        <div class="checkbox">
          @if (hasFieldNotes('hasNoAdditives') || isInReview) {
            <span>
              <view-notes [fieldName]="'hasNoAdditives'" [notes]="getFilteredNotes('hasNoAdditives')" (notesRequested)="handleNotesRequested($event)"></view-notes>
            </span>
          }
          <input class="show-for-sr" id="hasNoAdditives" type="checkbox" formControlName="hasNoAdditives" (change)="onHasAdditivesClicked($event)" />
          <label for="hasNoAdditives">
            No surface hole additives were used. Form 8A not applicable.
            <span class="checkbox-box"><span class="checkbox-check">&#x2714;</span></span>
          </label>
        </div>
      </div>
    }


    @if (!hasNoAdditives) {
      <div class="grid-x grid-margin-x padding-bottom-large section">
        <div class="cell small-12 medium-12 large-12 bold">
          Upload Form 8A Surface Hole Additives Report: <span class="bold">*</span>
        </div>
        @if (!hasNoAdditives) {
          <div class="cell small-12 medium-12 large-12">
            @if (hasFieldNotes('uploadedFiles')) {
              <span> <view-notes [fieldName]="'uploadedFiles'" [notes]="getFilteredNotes('uploadedFiles')" (notesRequested)="handleNotesRequested($event)"></view-notes></span>
            }
            <upload-view-files [uniqueId]="'uploader'" [files]="uploadedFiles" [isPadded]="false" [componentLabel]="''" [showFileList]="true" [allowDeletion]="uploadedFilesCtrl?.enabled" [allowUpload]="uploadedFilesCtrl?.enabled" (fileRemoved)="onFileDeleted($event)" (newFilesList)="fileAdded($event)">
            </upload-view-files>
          </div>
        }
        @if (isInternal) {
          <div class="cell">
            <label for="receivedDate">Form 8A Received Date</label>
            <common-date-picker id="receivedDate" (dateUpdated)="onDateUpdated($event, 'receivedDate')" [initialDate]="receivedDate"></common-date-picker>
          </div>
        }
      </div>
    }
    @if (!isInReview && wellIsSelected) {
      <div class="grid-x grid-margin-x ">
        @switch (true) {
          @case (!isInternal) {
            <div class="large-12 medium-12 small-12 text-align-center">
              <p>By clicking submit, I certify that the information provided is true and accurate, to the best of my knowledge.</p>
              <span class="minor-margin-right">
                <button class="button" (click)="saveForLater()">Save for Later</button>
              </span>
              <ng-container>
                <span class="minor-margin-right">
                  <button class="button" [disabled]="!filesUploaded && !hasNoAdditives" (click)="submit()">Submit</button>
                </span>
              </ng-container>
              <span>
                <button class="button" (click)="cancel()">Cancel</button>
              </span>
            </div>
          }
          @case (isInternal) {
            <div class="large-12 medium-12 small-12 text-align-center">
              @if (!isApproved && !isInCorrections) {
                <span class="minor-margin-right">
                  <button class="button" (click)="saveForLater()">Save for Later</button>
                </span>
              }
              @if (!isApproved && !isInCorrections) {
                <span class="minor-margin-right">
                  <button class="button" [disabled]="!filesUploaded && !hasNoAdditives" (click)="onAccept()">Accept</button>
                </span>
              }
              <span>
                <button class="button" (click)="cancel()">Cancel</button>
              </span>
            </div>
          }
        }
      </div>
    }

  </form>
</div>


